export const ajax = {
  x: function() {
    if (typeof XMLHttpRequest !== "undefined") {
      return new XMLHttpRequest();
    }
    var versions = [
      "MSXML2.XmlHttp.6.0",
      "MSXML2.XmlHttp.5.0",
      "MSXML2.XmlHttp.4.0",
      "MSXML2.XmlHttp.3.0",
      "MSXML2.XmlHttp.2.0",
      "Microsoft.XmlHttp"
    ];

    var xhr;
    for (var i = 0; i < versions.length; i++) {
      try {
        xhr = new ActiveXObject(versions[i]);
        break;
      } catch (e) {}
    }
    return xhr;
  },

  send: function(url, callback, method, data, async) {
    if (async === undefined) {
      async = true;
    }
    var x = this.x();
    x.open(method, url, async);
    x.onreadystatechange = function() {
      if (x.readyState == 4) {
        callback(x.responseText);
      }

      if (x.status == 429) {
        callback("<div className='errors'>Too Many Attemps. Try Again Later</div>");
      }
    };
    if (method == "POST") {
      x.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    }
    x.onerror = function() {
      callback("Error fetching", x.responseText);
    };
    x.send(data);
  },

  get: function(url, data, callback, async) {
    this.send(url, callback, "GET", null, async);
  },

  post: function(url, data, callback, async) {
    this.send(url, callback, "POST", data, async);
  }
};
